import apiService from "./apiService";

const businessService = {
    async getLinkedAccounts() {
        try {
            const resp = await apiService.get(`application/get-linked-businesses`, {}, true);
            return resp.data;
        }
        catch {
            return [];
        }
    },
    async getBusinessInfo(id) {
        try {
            const resp = await apiService.get(`application/${id}/get-my-business-info`, {}, true);
            return resp.data;
        }
        catch {
            return {};
        }
    },
    async getAllLobs() {
        try {
            const resp = await apiService.get(`business/get-all-lobs`, {}, true);
            return resp.data;
        }
        catch {
            return [];
        }
    },
    async save(data) {
        try {
            const resp = await apiService.post(`application/save`, data, true);
            return resp.data;
        }
        catch {
            return { success: false, message: 'An error occured while processing the request' };
        }
    },
}

export default businessService;